module.exports = __webpack_public_path__ + "img/logo-white.acd382ca.png";